import { Progress } from "semantic-ui-react";
import CommonProgress from "../../../components/CommonProgress/CommonProgress";
import LazyImage from "../../../components/Loading/lazyImage";
import { VipList } from "../vipList";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import PromotionCard from "./promotionCard";
import { TbPokerChip } from "react-icons/tb";
import { IoLogoGameControllerA } from "react-icons/io";
import useVipInfo from "../../../hook/useVipInfo";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../utils/formatNumber";
import { vipPromotion } from "../helper/detailList";
import VipPromotionList from "./vipPromotionList";

const MiniCard = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const navigate = useNavigate();
  const vipConfig = useVipInfo();

  const vipList = useSelector((state) => state.isVipDetail);

  const { nowLevel, nowWash } = vipConfig;
  return (
    <section
      className={`rounded-[5px] flex flex-col gap-[10px] items-center justify-center p-[15px] bg-gradient-to-br ${VipList[nowLevel]?.background}`}
    >
      <div className="w-full flex items-center justify-between">
        <div className="flex flex-col ">
          <span className="text-light-text font-medium">{i18n("nowBet")}.</span>
          <span className="font-semibold text-light-white text-2xl tracking-wide">
            {formatNumber(nowWash, { point: false })}
          </span>
        </div>
        <div className="w-[44px] h-[44px]">
          <LazyImage
            className="!w-[44px] !h-[44px]"
            src={vipList[nowLevel]?.icon}
            loadingClassName={`!rounded-full`}
          />
        </div>
      </div>
      <Progress
        className="customUi customUiHeight !mb-[0px] w-full"
        value={nowWash}
        total={vipList[nowLevel + 1]?.wash_max}
        size="tiny"
        success
      />
      <div className="w-full flex items-center justify-between">
        <span className="text-[#ABD010] font-medium">
          {formatNumber((nowWash / vipList[nowLevel + 1]?.wash_max) * 100)}%
        </span>
        <span className="text-xs text-light-text">
          {" "}
          {formatNumber(nowWash, { point: false })} /{" "}
          {formatNumber(vipList[nowLevel + 1]?.wash_max, { point: false })}{" "}
          {i18n("until")}{" "}
          <span
            onClick={() => {
              navigate(`profile/vip/${vipList?.[nowLevel + 1]?.level}`);
            }}
            className="text-[#ADB010] underline cursor-pointer"
          >
            {i18n(`${vipList[nowLevel + 1]?.label.toLowerCase()}`)}
          </span>
        </span>
      </div>
      <VipPromotionList className={`w-full`} />
    </section>
  );
};

export default MiniCard;
